/* eslint-disable @typescript-eslint/no-var-requires */
import { Tabs } from 'antd';
import TabPane from 'antd/lib/tabs/TabPane';
import React, { useState } from 'react';
import './animation047.less';
import AnswerCover from '../../components/answerCover';

import ImgPoint from '../../../../../assets/animation_point.gif';
import ImgPlus from '../../../../../assets/plus.png';
import ImgTipsPerson from '../../../../../assets/tips-person.png';

interface IAnimation047Props {
  tip?: string;
  tabName1: string;
  tabName2: string;
  panel1: string;
  panel2: string;
  panel3: string;
  panel4: string;
  panel5: string;
  panel6: string;
  panel7: string;
  panel8: string;
  highlight1: string;
  highlight2: string;
  highlight3: string;
  highlight4: string;
  className: string;
  onCompleted?: () => void;
}

const Animation047: React.FunctionComponent<IAnimation047Props> = ({
  tip,
  tabName1,
  tabName2,
  panel1,
  panel2,
  panel3,
  panel4,
  panel5,
  panel6,
  panel7,
  panel8,
  highlight1,
  highlight2,
  highlight3,
  highlight4,
  className,
  onCompleted,
}) => {
  const [state, setState] = React.useState({
    conversation: 0,
    animationPassword: false,
    coveredAnswer: 2,
  });
  const revealAnswer = () => {
    setState({
      ...state,
      coveredAnswer: state.coveredAnswer - 1,
    });
    if (state.coveredAnswer <= 1) {
      console.log('completed');
      onCompleted && onCompleted();
    }
  };
  const [tabValue2, setTabValue2] = useState('1');
  const [tabStatus2, setTabStatus2] = useState<number[]>([]);
  const handleCoverChange2 = (idx: number) => {
    setTabStatus2([...tabStatus2, idx]);
  };
  const checkTabIndicateHide2 = (index: number) =>
    !(
      Boolean(tabStatus2.find((itm) => itm.toString() === tabValue2)) &&
      Math.min(...[1, 2].filter((itm) => !tabStatus2.includes(itm))) === index
    );

  return (
    <div className={`topic-tab-section component tab2 ${className}`}>
      {tip && (
        <div className="tips" dangerouslySetInnerHTML={{ __html: tip }} />
      )}
      <Tabs
        type="card"
        className="topic-tab"
        onChange={(activeKey) => setTabValue2(activeKey)}
      >
        <TabPane
          tab={
            <>
              {tabName1}
              <img
                className="click-point-tab"
                hidden={checkTabIndicateHide2(1)}
                src={ImgPoint}
                alt=""
              />
            </>
          }
          key="1"
        >
          <img className="tips-person" src={ImgTipsPerson} alt="" />
          <div className="panel">
            <div className="l1">{panel1}</div>
            <div className="l2">{panel2}</div>
          </div>
          <img src={ImgPlus} alt="" />
          <div className="panel">
            <div className="l1">{panel3}</div>
            <div className="l2">{panel4}</div>
          </div>
          <AnswerCover
            onChange={revealAnswer}
            onCoverChange={() => handleCoverChange2(1)}
          >
            <div className="highlight-panel panel">
              <div className="l1">{highlight1}</div>
              <div className="l2">{highlight2}</div>
            </div>
          </AnswerCover>
        </TabPane>
        <TabPane
          tab={
            <>
              {tabName2}
              <img
                className="click-point-tab"
                hidden={checkTabIndicateHide2(2)}
                src={ImgPoint}
                alt=""
              />
            </>
          }
          key="2"
        >
          <img className="tips-person" src={ImgTipsPerson} alt="" />
          <div className="panel">
            <div className="l1">{panel5}</div>
            <div className="l2">{panel6}</div>
          </div>
          <img src={ImgPlus} alt="" />
          <div className="panel">
            <div className="l1">{panel7}</div>
            <div
              className="l2"
              dangerouslySetInnerHTML={{
                __html: panel8,
              }}
            />
          </div>
          <AnswerCover
            onChange={revealAnswer}
            onCoverChange={() => handleCoverChange2(2)}
          >
            <div className="highlight-panel panel">
              <div className="l1">{highlight3}</div>
              <div className="l2">{highlight4}</div>
            </div>
          </AnswerCover>
        </TabPane>
      </Tabs>
    </div>
  );
};

export default Animation047;
